export default __webpack_public_path__ + "static/media/check-icon-copy.67adfc27.svg";